import { memo, useEffect, useState } from "react"
import Input from "components/Commons/Input"
import { useForm } from "react-hook-form"
import { OptionFilterWrapper, SearchFormStyled } from "components/SearchForm/SearchForm.styled"
import { ButtonStyled } from "theme/common/Button.styled"
import { ISearch, ISearchForm } from "interfaces/ISearchForm"
import { IconSearch } from "theme/common/Icon.styled"
import { yupResolver } from "@hookform/resolvers/yup"
import { shemaSearchForm } from "config/ShemaForms"
import RadioButton from "components/Commons/RadioButton"
import { OptionsFilterEnum } from "enums/OptionsFilterEnum"
import { filterOrderData } from "theme/assets/Data/FiltersData"

const SearchForm = memo(({ onClickSearch, search, optionFilter, isLoading }: ISearch) => {
  const [filter, setFilterValue] = useState(OptionsFilterEnum.query.toString())
  const { register, handleSubmit, setValue } = useForm<ISearchForm>({
    resolver: yupResolver(shemaSearchForm),
  })

  useEffect(() => {
    if (search) setValue("search", search)
    if (optionFilter) setFilterValue(optionFilter)
  }, [search, setValue, optionFilter])

  const handleClickSubmit = ({ search }: ISearchForm) => {
    onClickSearch({ query: search, optionFilter: filter })
  }

  const handleChangeOptionFilter = (ev: React.ChangeEvent<HTMLInputElement>) => {
    setFilterValue(ev.target.value)
  }

  const resultPlaceHolder = filterOrderData.find(({ value }) => value === filter)?.label

  return (
    <>
      <OptionFilterWrapper>
        {filterOrderData.map(({ value, label }) => (
          <RadioButton
            key={value}
            name="optionFilter"
            value={value}
            checked={value === filter}
            onChange={handleChangeOptionFilter}
          >
            {label}
          </RadioButton>
        ))}
      </OptionFilterWrapper>
      <SearchFormStyled onSubmit={handleSubmit(handleClickSubmit)}>
        <ButtonStyled variant="primary" disabled={isLoading}>
          <span>BUSCAR</span>
          <IconSearch />
        </ButtonStyled>
        <Input type="search" placeHolder={resultPlaceHolder} {...register("search")} />
      </SearchFormStyled>
    </>
  )
})

export default SearchForm
